import { methodDetailsActionTypes } from './Constants';

export function getMethodDetailsRequest(id, query, firstLoad) {
	return {
		type: methodDetailsActionTypes.GET_METHOD_DETAILS_REQUEST,
		payload: {
			id,
			query,
			firstLoad,
		},
	};
}

export function getMethodDetailsSuccess(data) {
	return {
		type: methodDetailsActionTypes.GET_METHOD_DETAILS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getMethodDetailsError() {
	return {
		type: methodDetailsActionTypes.GET_METHOD_DETAILS_ERROR,
	};
}

export function changeFilters(data) {
	return {
		type: methodDetailsActionTypes.CHANGE_METHOD_DETAILS_FILTERS,
		payload: { data },
	};
}

export function clearMethodDetails() {
	return {
		type: methodDetailsActionTypes.CLEAR_METHOD_DETAILS,
		payload: {},
	};
}
